import { useState, useEffect, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { ReactComponent as AlertIcon } from "@/assets/images/desktop/alert.svg";

import classes from "../../../Purchase/OrdersSale/Create/createOrderSale.module.scss";

const UnitLoadItemSuggestions = ({ suggestions, index, data, setData, isGeneric = false }) => {
	const refButton = useRef(null);
	const refDiv = useRef(null);

	const [openSave, setOpenSave] = useState(false);

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
	}, []);

	const handleClickOutside = (event) => {
		if (refButton.current && !refButton.current.contains(event.target) && refDiv.current && !refDiv.current.contains(event.target)) {
			setOpenSave(false);
		}
	};

	const handleSelectProduct = (i) => {
		let newItems = [...data.items];
		if (isGeneric) {
			newItems[index]["generic"] = suggestions[i].product_id;
			newItems[index]["generic_suggestions"] = [];
		} else {
			newItems[index]["product_id"] = suggestions[i].product_id;
			newItems[index]["product_suggestions"] = [];
		}
		setOpenSave(false);
		setData({ ...data, items: newItems });
	};

	return (
		<div className={classes.div_suggestion}>
			<OverlayTrigger overlay={<Tooltip>{`Existen ${isGeneric ? "genéricos" : "productos"} sugeridos`}</Tooltip>}>
				<AlertIcon
					className={`${classes.buttonSuggestions}`}
					onClick={() => {
						setOpenSave(!openSave);
					}}
					ref={refButton}
				/>
			</OverlayTrigger>

			<div className={`${classes.saveAsList} ${openSave && classes.active} `} ref={refDiv}>
				<div className={classes.saveAsTitle}>Sugerencias</div>
				<hr className={classes.saveAsHr} />
				{suggestions.map((p, i) => {
					return (
						<div className={`${classes.saveAsListItem}`} key={i} onClick={() => handleSelectProduct(i)}>
							<span> {p.name} </span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default UnitLoadItemSuggestions;
